import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { EmptyDictPrompt } from "./EmptyDictPrompt";

/**
 * WizardStep1 — Pick a beden serisi + multi-select which sizes actually
 * belong in this specific table. Selection order is preserved (Snapshot
 * pattern) so the merchant's exact taxonomy renders in the widget.
 */
export const WizardStep1 = ({ series, seriesId, onPickSeries, pickedSizes, onToggleSize, onPickAll, onClearAll, selectedSeries }) => {
    if (series.length === 0) {
        return <EmptyDictPrompt kind="series" />;
    }
    return (
        <div className="space-y-4" data-testid="wizard-step-1">
            <div>
                <div className="text-[11px] font-semibold tracking-wider uppercase text-muted-foreground mb-2">
                    Hangi seriden bedenleri seçeceksin?
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {series.map((s) => (
                        <button
                            key={s.id}
                            onClick={() => onPickSeries(s.id)}
                            className={`text-left rounded-lg border p-3 transition-all ${seriesId === s.id ? "border-foreground/40 bg-muted/40 ring-1 ring-foreground/10" : "border-border bg-surface hover:border-foreground/20"}`}
                            data-testid={`series-option-${s.id}`}
                        >
                            <div className="flex items-center justify-between gap-2">
                                <div className="min-w-0">
                                    <div className="font-display text-sm font-bold tracking-tight truncate">{s.name}</div>
                                    {s.scope && <div className="text-[10.5px] text-muted-foreground truncate">{s.scope}</div>}
                                </div>
                                <Badge variant="outline" className="text-[10px] font-mono shrink-0">{s.sizes.length}</Badge>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {selectedSeries && (
                <div className="rounded-xl border border-border bg-surface" data-testid="size-multiselect">
                    <div className="px-4 py-3 border-b border-border flex items-center justify-between gap-2">
                        <div>
                            <div className="text-[11px] font-semibold tracking-wider uppercase text-muted-foreground">
                                Bu tabloda hangi bedenler olsun?
                            </div>
                            <div className="text-[10.5px] text-muted-foreground mt-0.5">
                                {selectedSeries.name} setinden ihtiyaç duyduklarını işaretle · <span className="text-foreground/70">{selectedSeries.name}&apos;nın sonraki güncellemeleri bu tabloyu etkilemez</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-1 shrink-0">
                            <Button size="sm" variant="ghost" className="h-7 text-[11px]" onClick={onPickAll} data-testid="pick-all-sizes">Tümünü Seç</Button>
                            <Button size="sm" variant="ghost" className="h-7 text-[11px] text-muted-foreground" onClick={onClearAll}>Temizle</Button>
                        </div>
                    </div>
                    <div className="p-3">
                        <div className="flex flex-wrap gap-1.5">
                            {selectedSeries.sizes.map((sz) => {
                                const active = pickedSizes.includes(sz);
                                return (
                                    <button
                                        key={sz}
                                        onClick={() => onToggleSize(sz)}
                                        className={`min-w-[3rem] inline-flex items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-display font-bold transition-all border ${
                                            active
                                                ? "bg-foreground text-background border-foreground"
                                                : "bg-background text-foreground border-border hover:border-foreground/40"
                                        }`}
                                        data-testid={`size-toggle-${sz}`}
                                    >
                                        {active && <Check className="h-3 w-3" strokeWidth={3} />}
                                        {sz}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="mt-3 text-[11px] text-muted-foreground">
                            <span className="font-medium text-foreground">{pickedSizes.length}</span> beden seçildi · tablo {pickedSizes.length} satır olacak
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
